import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { CardInsertBlock } from '../blocks/CardInsertBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const CardInsertsLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { cardInserts } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {cardInserts.map((item, index) => (
        <CardInsertBlock key={index} cardInsert={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default CardInsertsLayer
